import { render, staticRenderFns } from "./AccessModal.component.vue?vue&type=template&id=142d07e2"
import script from "./AccessModal.component.vue?vue&type=script&lang=js"
export * from "./AccessModal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports